// extracted by mini-css-extract-plugin
export default {"container":"loadPage_container__B+RL0","containerContent":"loadPage_containerContent__vUoDu"};